import React, { useState, useContext, useEffect } from 'react';
import { SplitFactory, SplitContext, useTreatments } from '@splitsoftware/splitio-react';

var getsdkConfig = function (id, trafficType) {
    return ({
        core: {
            authorizationKey: process.env.REACT_APP_SPLIT,
            key: id,
            trafficType: trafficType,
        },
    });
};
var SplitProvider = function (_a) {
    var children = _a.children, trafficType = _a.trafficType, id = _a.id;
    var sdkConfig = getsdkConfig(id, trafficType);
    return React.createElement(SplitFactory, { config: sdkConfig }, children);
};

var TrafficTypes;
(function (TrafficTypes) {
    TrafficTypes["USER"] = "user";
    TrafficTypes["ANONYMOUS"] = "anonymous";
    TrafficTypes["LIISA"] = "liisa";
})(TrafficTypes || (TrafficTypes = {}));

var useTreatment = function (splitTreatment, attributes) {
    var _a = useState(null), treatmentOn = _a[0], setTreatmentOn = _a[1];
    var isReady = useContext(SplitContext).isReady;
    var treatments = useTreatments([splitTreatment], attributes);
    useEffect(function () {
        if (!isReady) {
            return;
        }
        setTreatmentOn(treatments[splitTreatment].treatment === 'on');
    }, [isReady, treatments]);
    return treatmentOn;
};

var useTreatmentWithConfig = function (splitTreatment, attributes) {
    var _a = useState(null), treatmentOn = _a[0], setTreatmentOn = _a[1];
    var _b = useState(null), config = _b[0], setConfig = _b[1];
    var isReady = useContext(SplitContext).isReady;
    var treatments = useTreatments([splitTreatment], attributes);
    useEffect(function () {
        if (!isReady) {
            return;
        }
        if (treatments[splitTreatment].treatment === 'on') {
            setTreatmentOn(true);
            setConfig(treatments[splitTreatment].config);
        }
        else {
            setTreatmentOn(false);
        }
    }, [treatments]);
    var parsedConfig = JSON.parse(config !== null && config !== void 0 ? config : '{}');
    return { treatmentOn: treatmentOn, config: parsedConfig };
};

// Only use this function if you have already previously ensured the split client is ready in a parent component
// Currently, only dashboard is set up to use this
var useTreatmentNoReadyCheck = function (splitTreatment, attributes) {
    var treatments = useTreatments([splitTreatment], attributes);
    return treatments[splitTreatment].treatment === 'on';
};

export { SplitProvider, TrafficTypes, useTreatment, useTreatmentNoReadyCheck, useTreatmentWithConfig };
